
import { Component, Prop, Vue } from 'vue-property-decorator'

export interface SectionPillItem {
  id: string
  label: string
  badge?: string | number
}

@Component({ name: 'SectionPills' })
export default class extends Vue {
  @Prop({ required: true }) value!: string
  @Prop({ required: true }) items!: SectionPillItem[]
}
